import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ProcessTaskDefinitionEntity } from './process-task-definition.entity';
import { ProcessTaskHistoryEntity } from './process-task-history.entity';

@Index(
	'process_task__fk_process_definition__id_fk',
	['fkProcessDefinitionId'],
	{},
)
@Index(
	'process_task__fk_process_task_definition__id_fk',
	['fkProcessTaskDefinitionId'],
	{},
)
@Index(
	'process_task__fk_process_task_history__id_fk',
	['fkProcessTaskHistoryId'],
	{},
)
@Entity('process_task')
export class ProcessTaskEntity extends BaseEntity {
	@Column('int', {
		name: '_fk_process_definition__id',
		nullable: true,
		unsigned: true,
	})
	public fkProcessDefinitionId!: number | null;

	@Column('int', { name: '_fk_process_task_definition__id', unsigned: true })
	public fkProcessTaskDefinitionId!: number;

	@Column('int', { name: 'object__id' })
	public objectId!: number;

	@Column('int', { name: 'object_record__id' })
	public objectRecordId!: number;

	@Column('datetime', { name: 'follow_up', nullable: true })
	public followUp!: Date | null;

	@Column('int', { name: '_fk_process_task_history__id', unsigned: true })
	public fkProcessTaskHistoryId!: number;

	@Column('varchar', { name: 'status', length: 255 })
	public status!: string;

	@ManyToOne(
		() => ProcessTaskDefinitionEntity,
		(processTaskDefinition) => processTaskDefinition.processTasks,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk_process_task_definition__id', referencedColumnName: 'id' },
	])
	public fkProcessTaskDefinition!: ProcessTaskDefinitionEntity;

	@ManyToOne(
		() => ProcessTaskHistoryEntity,
		(processTaskHistory) => processTaskHistory.processTasks,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk_process_task_history__id', referencedColumnName: 'id' },
	])
	public fkProcessTaskHistory!: ProcessTaskHistoryEntity;
}
